import { groupBy, isEmpty, mapValues } from 'lodash';

/**
 * Pure selector functions extracted from OrderRequestV2Provider for testability.
 * The context provider wraps these with closure state (entities, wip).
 */

export function filterTestsByAssayId(testsMap, wipTestIds, assayId) {
  if (!assayId || isEmpty(wipTestIds) || isEmpty(testsMap)) return [];
  return Object.values(testsMap).filter(
    (test) => test.assay === assayId && !test.panel && wipTestIds.includes(test.id)
  );
}

export function filterTestsByPanelId(testsMap, wipTestIds, panelId) {
  if (!panelId || isEmpty(wipTestIds) || isEmpty(testsMap)) return [];
  return Object.values(testsMap).filter(
    (test) => test.panel === panelId && wipTestIds.includes(test.id)
  );
}

export function filterTestsByPanelAssayId(testsMap, wipTestIds, panelId, assayId) {
  if (!panelId || !assayId || isEmpty(wipTestIds) || isEmpty(testsMap)) return [];
  return Object.values(testsMap).filter(
    (t) => t.panel === panelId && t.assay === assayId && wipTestIds.includes(t.id)
  );
}

export function groupTestsBySampleIdAssayPanelId(testArr = [], isPanel = false) {
  return mapValues(groupBy(testArr, 'sample_id'), (x) =>
    mapValues(groupBy(x, isPanel ? 'panel_id' : 'assay_id'), (y) =>
      y.map((z) => z.id)
    )
  );
}
